<form (ngSubmit)="next()" (keydown.enter)="$event.preventDefault()">
    <h2 i18n>Information about the Letter</h2>
    @if (file) {
    <ell-file-list [readonly]="true" [files]="[file]" />
    }
    <p>
        Please provide information separately for each file you are going to upload.
    </p>

    <ell-survey-question i18n-question question="How long before the person died did they produce this text?"
        type="text-field" [(answer)]="answers['beforeDeath']" name="beforeDeath" />

    <p><em>Please give approximate time in days if possible.</em></p>

    <ell-survey-question i18n-question
        question="Who was the text intended for, as far as you know? (More than one answer possible)"
        type="checkbox-select" [(answer)]="answers['audience']" name="audience" [options]="audienceOptions"
        [other]="true" />

    <ell-survey-question i18n-question question="Which country was the writer living in when they wrote the letter?"
        [other]="true" [options]="countryOptions" type="dropdown-select" [(answer)]="answers['country']"
        name="country" />

    <ell-survey-question i18n-question question="Which language(s) is the text written in?" type="text-field"
        [(answer)]="answers['language']" name="language" />

    <ell-survey-question i18n-question question="What format was this text produced in?" type="radio-select"
        [(answer)]="answers['format']" name="format" [options]="formatOptions" />

    @if (openFormatOptions.has(answers['format'])) {
    <ell-survey-question i18n-question question="Additional details about the format" type="text-field"
        [(answer)]="answers['formatDetails']" name="formatDetails" />
    }

    <ell-survey-question i18n-question question="Do you want to provide any further information about this letter or the circumstances in which it was produced? For
example, if names appear in the letter, what relationship were the named people to the writer? (NB all names will be
changed before making the text available)" type="textarea" [(answer)]="answers['furtherInformation']"
        name="furtherInformation" [options]="formatOptions" />

    <p>
        Please see the <a [routerLink]="['/', 'privacy']" target="_blank">Privacy Statement</a> for information on how
        data on living persons is processed.
    </p>

    <input type="submit" class="btn btn-primary" value="Next" i18n-value />
</form>
